import {FormControl} from '@angular/forms';

export interface ICookieConsentForm {
  necessary: FormControl<boolean | null>;
  performance: FormControl<boolean | null>;
  targeting: FormControl<boolean | null>;
  functionality: FormControl<boolean | null>;
  unclassified: FormControl<boolean | null>;
}

export interface ICookieConsentFormValue {
  necessary: boolean;
  performance: boolean;
  targeting: boolean;
  functionality: boolean;
  unclassified: boolean;
}

export interface ICookie {
  name: string;
  provider: string;
  providerLink: string;
  runtime: string;
  purpose: string;
  type: ECookieType;
}

export enum ECookieType {
  StrictlyNecessary = 'StrictlyNecessary',
}

export enum ECookieConsent {
  Consent = 'Consent',
}

export type CookieSameSite = 'Strict' | 'Lax' | 'None' | undefined;
export type CookieExpiration = number | string | null;
export type ECookieConsentState = ECookieConsent | ECookieType;
